import { BrandNode, PaginaNode } from '@gql/graphql'
import { useFindMenu, useTrans } from 'hooks'
import { HeaderBrand, PlaceholderReact } from '@components/molecules'
import { BrandType } from '@components/molecules/HeaderBrand/HeaderBrand'
import {
  BrandsSection,
  CollezioniSection,
  HeroStickyBar,
  HeroStickyBarMobile,
  MagazineSection,
  Page,
  Prefooter,
  ProgettiSection,
} from 'components/organisms'
import styles from './BrandTemplate.module.sass'
import useTransRoute from '@hooks/useTransRoute'
import { useEffect } from 'react'
import { collezioneToTrack, trackingEcommerceEvent } from '@utils/gtm'

interface Props {
  pagina?: PaginaNode
  brand?: BrandNode
}

const BrandTemplate = (props: Props) => {
  const { pagina = undefined, brand = undefined } = props

  const t = useTrans()
  const tRoute = useTransRoute()

  const stickyBarOptions = [
    ...(brand?.collezioni?.length ? [{ label: t('Collezioni'), url: '#collections' }] : []),
    ...(brand?.progetti?.length ? [{ label: t('Progetti'), url: '#projects' }] : []),
    ...(brand?.magazines?.length ? [{ label: t('News'), url: '#news' }] : []),
    { label: t('Contatti'), url: tRoute('/contatti')?.href },
  ]

  const defaultContent1 = brand?.pagebuilders?.find((x) => x.key === 'main') ?? null

  const brandMenu = useFindMenu('pagina-brand-detail')
  const collezioniMenu = useFindMenu('collezioni-slider', brandMenu)
  const collezioniMenuBrand = useFindMenu(`collezioni-${brand.slug}-slider`, brandMenu)
  const progettiMenu = useFindMenu('progetti-slider', brandMenu)
  const blogMenu = useFindMenu('blog-slider', brandMenu)

  const handleClickTracking = (item, index) => {
    trackingEcommerceEvent('select_item', {
      item_list_id: brand?.pk || 0,
      item_list_name: brand?.slug || '',
      items: [collezioneToTrack(item, index, brand)],
    })
  }

  useEffect(() => {
    trackingEcommerceEvent('view_item_list', {
      item_list_id: brand?.pk,
      item_list_name: brand?.slug || '',
      items: brand?.collezioni?.slice(0, 4).map((p, index) => {
        return collezioneToTrack(p, index, brand)
      }),
    })
  }, [])

  return (
    <Page
      pagina={{
        ...pagina,
        seo: { ...pagina.seo, title: brand.title, description: brand.description },
      }}
      className={`${styles.root}`}
      item={brand}
    >
      <main>
        <HeroStickyBar label={brand?.nome} options={stickyBarOptions} />
        <HeroStickyBarMobile label={brand?.nome} options={stickyBarOptions} />
        <h1 aria-label={brand?.nome}>
          <span style={{ display: 'none' }}>{brand?.nome}</span>
          <HeaderBrand brand={brand?.slug as BrandType} />
        </h1>
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={brand.model}
            objectId={brand.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <CollezioniSection
          refId="collections"
          collezioni={brand?.collezioni?.slice(0, 4)}
          item={collezioniMenuBrand || collezioniMenu}
          theme="neutral20"
          handleClickTracking={handleClickTracking}
        />
        <ProgettiSection
          refId="projects"
          progetti={brand?.progetti}
          idBrand={brand?.pk}
          item={progettiMenu}
          theme="neutral10"
        />
        <BrandsSection brands={brand?.correlati} theme="white" />
        <MagazineSection
          refId={'news'}
          magazines={brand.magazines}
          item={blogMenu}
          theme="neutral10"
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default BrandTemplate
